<template>
	<div class="page flex-column">
		<div class="head flex-center">
			<div class="outlet flex-center" v-if="outletList.length">
				<span>切换网点：</span>
				<div class="outlet-select">
					<select v-model="currentOutletId" @change="onOutletChange">
						<option v-for="item in outletList" :key="item.id" :value="item.id">{{item.outlet_name}}</option>
					</select>
				</div>
			</div>
			<div class="date flex-center">数据更新：{{date}}</div>
			<h1>永利带业固定资产分析</h1>
		</div>

		<div class="body flex-column flex-grow">
			<div class="total flex">
				<div class="box total-item flex-grow flex-column flex-center-main">
					<p class="label">📦 总资产数</p>
					<div class="flex-baseline">
						<strong class="tf-num">{{kpi.total_count || 0}}</strong>
						<span>车辆: {{kpi.vehicle_count || 0}}</span>
						<span>机台: {{kpi.machine_count || 0}}</span>
					</div>
				</div>
				<div v-for="(item, i) in kpiList" :key="i" class="box total-item flex-grow flex-column flex-center-main">
					<p class="label">{{['✅', '🔧', '❌', '⏸', '⚡'][i]}} {{item.label}}</p>
					<div class="flex-baseline">
						<strong class="tf-num">{{item.value || 0}}</strong>
						<span>占比: {{item.rate}}%</span>
					</div>
				</div>
			</div>

			<div class="box flex-column" style="flex-grow: 334; height: 0;">
				<div class="box-head flex-between-center">
					<p class="box-title">⚡ 占用设备</p>
					<ul class="box-tab flex">
						<li v-for="(item, i) in occupiedCategoryCounts" :key="i" class="tag" :class="{'z-crt': occupiedType == item.label}" @click="occupiedType = item.label">{{item.label}}({{item.count}})</li>
					</ul>
				</div>
				<c-scroll v-if="occupiedList[occupiedType] && occupiedList[occupiedType].length" class="occupied flex-grow" bar-color="rgba(255,255,255,.3)">
					<ul class="flex-wrap">
						<li v-for="(item, i) in occupiedList[occupiedType]" :key="i" class="flex-column">
							<div class="flex-start-center">
								<span class="occupied-type">{{item.asset_category}}</span>
								<span class="occupied-name">{{item.asset_name}}</span>
							</div>
							<div class="occupied-info flex">
								<p>
									<label>领用人</label>
									<span><b>{{item.last_use_user}}</b></span>
								</p>
								<p v-if="item.aftersale_order_number">
									<label>服务工单</label>
									<span><b>{{item.aftersale_order_number}}</b></span>
								</p>
							</div>
							<div class="occupied-info">
								<p>
									<label><i class="tf">&#xe6d7;</i></label>
									<span>{{item.order_address || '未知'}}</span>
								</p>
							</div>
						</li>
					</ul>
				</c-scroll>
				<c-empty v-else class="flex-grow"></c-empty>
			</div>

			<div class="flex" style="gap: .2rem; flex-grow: 484; height: 0;">
				<div class="box flex-grow flex-column">
					<div class="box-head flex-between-center">
						<p class="box-title">⏸ 空闲中设备</p>
						<ul class="box-tab flex">
							<li v-for="(item, i) in idleCategoryCounts" :key="i" class="tag" :class="{'z-crt': idleType == item.label}" @click="idleTabHandle(item.label)">{{item.label}}({{item.count}})</li>
						</ul>
					</div>
					<div v-if="compIdleList.length" ref="idle" class="idle flex-grow" bar-color="rgba(255,255,255,.3)">
						<ul ref="idleList" :class="{'z-scroll': idleListScroll}" :style="{'animation-duration': `${compIdleList.length * 1.2}s`}">
							<li v-for="(item, i) in compIdleList" :key="i" class="flex-center">
								<span class="idle-type">{{item.asset_category}}</span>
								<p class="flex-grow">{{item.asset_name}}</p>
								<span class="idle-state flex-center">空闲</span>
							</li>
						</ul>
					</div>
					<c-empty v-else class="flex-grow"></c-empty>
				</div>

				<div class="box flex-grow flex-column">
					<div class="box-head flex-between-center">
						<p class="box-title">🔧 维修中设备</p>
					</div>
					<c-scroll v-if="repairingList.length" class="repair flex-grow" bar-color="rgba(255,255,255,.3)">
						<ul>
							<li v-for="(item, i) in repairingList" :key="i" class="flex-center">
								<div class="flex-column flex-grow">
									<div class="flex-start-center">
										<span class="repair-type">{{item.asset_category}}</span>
										<span class="repair-name">{{item.asset_name}}</span>
									</div>
									<div class="repair-info flex">
										<p>
											<label>报修人</label>
											<span><b style="color: #F5A623;">{{item.sender_user_name}}</b></span>
										</p>
										<p class="ellipsis">
											<label>报修原因</label>
											<span><b>{{item.repair_summary}}</b></span>
										</p>
									</div>
								</div>
								<div class="repair-state">维修中</div>
							</li>
						</ul>
					</c-scroll>
					<c-empty v-else class="flex-grow"></c-empty>
				</div>

				<div class="flex-column flex-grow" style="gap: .2rem;">
					<div class="box flex-grow flex-column" style="flex-grow: 250; height: 0;">
						<div class="box-head flex-between-center">
							<p class="box-title">📈 各类资产状态分布</p>
						</div>
						<div ref="statusChart" class="chart flex-grow"></div>
					</div>
					
					<div class="box">
						<div class="box-head flex-between-center">
							<p class="box-title">📋 资产完好率</p>
						</div>
						<div class="intact">
							<p class="intact-rate">{{intactRate}}%</p>
							<div class="intact-rate-bar">
								<div :style="{width: intactRate + '%'}"></div>
							</div>
							<div class="intact-info flex-between">
								<p>正常资产 <span>{{normalCount}}</span></p>
								<p>维修/报废 <span style="color: #FF5555;">{{repairOrScrappedCount}}</span></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'

	export default {
		data() {
			return {
				date: '',
				// 网点切换
				outletList: [],
				currentOutletId: '',
				// KPI
				kpi: {},
				kpiList: [],
				// 占用设备
				occupiedCategoryCounts: [],
				occupiedType: '',
				occupiedList: {},
				// 空闲设备
				idleCategoryCounts: [],
				idleType: '',
				idleList: {},
				idleListScroll: false,
				// 维修设备
				repairingList: [],
				// 状态分布（柱状图）
				statusDistribution: [],
				statusChart: null,
				// 完好率
				intactRate: 0,
				normalCount: 0,
				repairOrScrappedCount: 0
			}
		},

		computed: {
			currentIdleList() {
				return this.idleList[this.idleType] || [];
			},

			compIdleList() {
				return this.currentIdleList.concat(this.idleListScroll ? this.currentIdleList : []);
			}
		},

		watch: {
			currentIdleList() {
				this.idleListScroll = false;
				this.$nextTick(() => {
					if (this.$refs.idleList.clientHeight > this.$refs.idle.clientHeight) {
						this.idleListScroll = true;
					} else {
						this.idleListScroll = false;
					}
				});
			}
		},

		mounted() {
			this.loadOutlets();
			this._resizeTimer = null;
			window.addEventListener('resize', () => {
				clearTimeout(this._resizeTimer);
				this._resizeTimer = setTimeout(() => {
					if (this.statusChart) this.statusChart.resize();
				}, 300);
			});
			setInterval(this.loadAll, 60000);
		},

		beforeDestroy() {
			clearInterval(this._occupiedTimer);
			clearTimeout(this._idleTimer);
			if (this.statusChart) {
				this.statusChart.dispose();
			}
		},

		methods: {
			/** 加载用户可见网点 */
			loadOutlets() {
				this.request({
					url: '/visual/data/asset/user_outlets',
					success: data => {
						this.outletList = data.outlets || [];
						if (this.outletList.length && !this.currentOutletId) {
							this.currentOutletId = data.selected_outlet_id || this.outletList[0].id;
						}
						this.date = data.updated_at || '';
						this.loadAll();
					}
				});
			},

			/** 网点切换 */
			onOutletChange() {
				this.loadAll();
			},

			/** 获取请求公共参数 */
			getParams() {
				let params = {};
				if (this.currentOutletId) {
					params.outlet_id = this.currentOutletId;
				}
				return params;
			},

			/** 加载全部数据 */
			loadAll() {
				this.loadKpi();
				this.loadOccupiedList();
				this.loadIdleList();
				this.loadRepairingList();
				this.loadStatusDistribution();
				this.loadIntactRate();
				this.date = new Date().format('yyyy/MM/dd hh:mm');
			},

			/** KPI 指标 */
			loadKpi() {
				this.request({
					url: '/visual/data/asset/kpi',
					data: this.getParams(),
					success: data => {
						let kpis = data.kpis || {};
						this.kpi = kpis;
						this.kpiList = [
							{label: '正常', value: kpis.normal_count || 0, rate: kpis.normal_percent},
							{label: '维修中', value: kpis.repairing_count || 0, rate: kpis.repairing_percent},
							{label: '已报废', value: kpis.scrapped_count || 0, rate: kpis.scrapped_percent},
							{label: '空闲', value: kpis.idle_count || 0, rate: kpis.idle_percent},
							{label: '占用中', value: kpis.occupied_count || 0, rate: kpis.occupied_percent}
						];
						if (data.updated_at) this.date = data.updated_at;
					}
				});
			},

			/** 占用设备列表 */
			loadOccupiedList() {
				clearInterval(this._occupiedTimer);
				this.request({
					url: '/visual/data/asset/occupied_list',
					data: this.getParams(),
					success: data => {
						this.occupiedCategoryCounts = this.formatCategoryCounts(data.category_counts);
						this.occupiedList = {};
						this.occupiedCategoryCounts.forEach(item => {
							this.$set(this.occupiedList, item.label, (data.list || []).filter(temp => temp.asset_category == item.label));
						});
						if (data.updated_at) this.date = data.updated_at;
						
						this.occupiedTabHandle(this.occupiedCategoryCounts[0] ? this.occupiedCategoryCounts[0].label : '');
					}
				});
			},

			occupiedTabHandle(val) {
				clearInterval(this._occupiedTimer);
				this.occupiedType = val;
				if (this.occupiedType) {
					this._occupiedTimer = setInterval(() => {
						let index = this.occupiedCategoryCounts.findIndex(item => item.label == this.occupiedType) + 1;
						this.occupiedType = this.occupiedCategoryCounts[index] ? this.occupiedCategoryCounts[index].label : this.occupiedCategoryCounts[0].label;
					}, 20000);
				}
			},

			/** 空闲设备列表 */
			loadIdleList() {
				clearTimeout(this._idleTimer);
				this.request({
					url: '/visual/data/asset/idle_list',
					data: this.getParams(),
					success: data => {
						this.idleCategoryCounts = this.formatCategoryCounts(data.category_counts);
						this.idleList = {};
						this.idleCategoryCounts.forEach(item => {
							this.$set(this.idleList, item.label, (data.list || []).filter(temp => temp.asset_category == item.label));
						});
						if (data.updated_at) this.date = data.updated_at;
						this.idleTabHandle(this.idleCategoryCounts[0] ? this.idleCategoryCounts[0].label : '');
					}
				});
			},
			
			idleTabHandle(val) {
				clearTimeout(this._idleTimer);
				this.idleType = val;
				if (this.idleType) {
					!function loop() {
						this._idleTimer = setTimeout(() => {
							let index = this.idleCategoryCounts.findIndex(item => item.label == this.idleType) + 1;
							this.idleType = this.idleCategoryCounts[index] ? this.idleCategoryCounts[index].label : this.idleCategoryCounts[0].label;
							loop.call(this);
						}, Math.max(this.idleList[this.idleType].length * 1200, 20000));
					}.call(this);
				}
			},

			/** 维修设备列表 */
			loadRepairingList() {
				this.request({
					url: '/visual/data/asset/repairing_list',
					data: this.getParams(),
					success: data => {
						this.repairingList = data.list || [];
						if (data.updated_at) this.date = data.updated_at;
					}
				});
			},

			/** 各类资产状态分布 */
			loadStatusDistribution() {
				this.request({
					url: '/visual/data/asset/status_distribution',
					data: this.getParams(),
					success: data => {
						this.statusDistribution = data.distribution || [];
						if (data.updated_at) this.date = data.updated_at;
						this.$nextTick(() => this.renderStatusChart());
					}
				});
			},

			/** 资产完好率 */
			loadIntactRate() {
				this.request({
					url: '/visual/data/asset/intact_rate',
					data: this.getParams(),
					success: data => {
						this.intactRate = data.intact_rate || 0;
						this.normalCount = data.normal_count || 0;
						this.repairOrScrappedCount = data.repair_or_scrapped_count || 0;
						if (data.updated_at) this.date = data.updated_at;
					}
				});
			},

			/** 格式化分类计数为 [{label, count}] */
			formatCategoryCounts(counts) {
				if (!counts || !Array.isArray(counts)) return [];
				return counts.map(item => ({
					label: item.asset_category || '',
					count: item.cnt || 0
				}));
			},

			/** 渲染状态分布柱状图 */
			renderStatusChart() {
				if (!this.$refs.statusChart) return;
				if (!this.statusChart) {
					this.statusChart = echarts.init(this.$refs.statusChart);
				}
				let dist = this.statusDistribution;
				let categories = dist.map(item => item.asset_category || '');
				let normalData = dist.map(item => item.normal_count || 0);
				let repairData = dist.map(item => item.repairing_count || 0);
				let scrappedData = dist.map(item => item.scrapped_count || 0);

				this.statusChart.setOption({
					tooltip: {trigger: 'axis'},
					legend: {
						data: ['正常', '维修', '报废'],
						textStyle: {color: '#a0cfff'},
						right: this.px(20),
						top: this.px(18)
					},
					grid: {left: this.px(60), right: this.px(20), bottom: this.px(40), top: this.px(82)},
					xAxis: {
						type: 'category',
						data: categories,
						axisLabel: {color: '#a0cfff'}
					},
					yAxis: {
						type: 'value',
						axisLabel: {color: '#a0cfff'},
						splitLine: {lineStyle: {color: 'rgba(255,255,255,.1)'}}
					},
					series: [
						{name: '正常', type: 'bar', data: normalData, itemStyle: {color: '#00F8C1'}},
						{name: '维修', type: 'bar', data: repairData, itemStyle: {color: '#FFBA00'}},
						{name: '报废', type: 'bar', data: scrappedData, itemStyle: {color: '#FF5555'}}
					]
				});
			},

			px(n) {
				return n * Math.min(1, 0.00052083 * window.innerWidth);
			}
		}
	}
</script>

<style lang="stylus">
	html {
		font-size: 5.2083vw;
	}
</style>

<style lang="stylus" scoped>
	.page {
		box-sizing: border-box;
		height: 100vh;
		overflow: hidden;
		background-color: #0D203A;
		user-select: none;

		.head {
			z-index: 1;
			position: relative;
			height: .72rem;
			margin-bottom: .22rem;
			background-image: url('~@/assets/image/digital/head.png');
			background-size: auto 100%;
			background-position: center;
			
			&:after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				width: .5rem;
				height: .02rem;
				background-image: url('~@/assets/image/digital/an_head.png');
				background-size: 100%;
				animation: headMove 5s infinite linear;
			
				@keyframes headMove {
					0% {
						opacity: 0;
						transform: translate(0,0);
					}
					10% {
						opacity: 1;
					}
					70% {
						opacity: 1;
					}
					80% {
						opacity: 0;
						transform: translate(100vw,0);
					}
					100% {
						opacity: 0;
						transform: translate(100vw,0);
					}
				}
			}

			h1 {
				padding-bottom: .05rem;
				font-size: .36rem;
				font-weight: normal;
				color: transparent;
				background: linear-gradient(0deg, #75DAFF 0%, #FFFFFF 100%);
				background-clip: text;
			}

			.outlet {
				position: absolute;
				top: .08rem;
				left: .88rem;
				font-size: .15rem;
				color: #00FFFF;

				&-select {
					box-sizing: border-box;
					width: 1.6rem;
					height: .28rem;
					border: 1px solid #00FFFF;
					border-radius: .14rem;
					padding: 0 .12rem;
					font-size: .15rem;
					color: #fff;
					background: #10567B;
					cursor: pointer;

					select {
						width: 100%;
						height: 100%;
						border: none;
						font-size: .15rem;
						color: #fff;
						background: #10567B;
						cursor: pointer;
					}
				}
			}

			.date {
				position: absolute;
				top: .16rem;
				right: 1rem;
				font-size: .13rem;
				color: #02F4FF;
			}
		}

		.body {
			padding: 0 .3rem .2rem;
			gap: .2rem;
		}
	}

	.box {
		box-sizing: border-box;
		border: 1px solid #1994D1;
		border-radius: .08rem;
		box-shadow: inset 0 0 .1rem .1rem rgba(25,148,209,.15);

		&-head {
			height: .62rem;
			padding: 0 .3rem;
		}

		&-title {
			font-size: .18rem;
			color: #98E3FF;
		}

		&-tab {
			gap: .24rem;

			li {
				position: relative;
				line-height: .3rem;
				font-size: .14rem;
				color: #F4D503;
				opacity: .7;
				cursor: pointer;

				&.z-crt {
					opacity: 1;

					&:after {
						content: '';
						position: absolute;
						left: 50%;
						bottom: 0;
						width: .36rem;
						height: .02rem;
						border-radius: .01rem;
						margin-left: -.18rem;
						background: #F4D503;
					}
				}
			}
		}
	}

	.total {
		gap: .24rem;

		&-item {
			gap: .18rem;
			position: relative;
			height: 1.08rem;
			padding: .12rem .28rem 0;
			color: #fff;
			background-image: url('~@/assets/image/digital/total_line.png');
			background-position: center top;
			background-size: auto .06rem;
			background-repeat: no-repeat;

			&:before, &:after {
				content: '';
				position: absolute;
				top: .1rem;
				width: .2rem;
				height: .04rem;
				background-image: url('~@/assets/image/digital/total_dot.png');
				background-size: 100% 100%;
			}
			&:before {
				left: .16rem;
			}
			&:after {
				right: .16rem;
			}

			.label {
				font-size: .13rem;
				color: #fff;
			}

			strong {
				font-size: .24rem;
				font-weight: bold;
			}

			span {
				margin-left: .12rem;
				font-size: .12rem;
				color: #91B0DA;
			}
		}
	}

	.occupied {
		ul {
			display: grid;
			grid-gap: .1rem;
			grid-template-columns: repeat(6, 1fr);
			padding: 0 .22rem .12rem;

			li {
				gap: .14rem;
				box-sizing: border-box;
				height: .95rem;
				border-radius: .06rem;
				padding: .1rem .12rem;
				background: #1A2C45;
			}
		}

		&-type {
			border: 1px solid #4A84B6;
			border-radius: .1rem;
			padding: 0 .08rem;
			line-height: .18rem;
			font-size: .12rem;
			color: #D5EFFF;
			background: #31587A;
		}

		&-name {
			margin-left: .08rem;
			font-size: .13rem;
			color: #fff;
		}

		&-info {
			gap: 1em;
			font-size: .12rem;
			color: #406F98;

			span {
				margin-left: .5em;
				color: #7ACAFC;
			}
		}
	}

	.idle {
		overflow: hidden;
		font-size: .13rem;
		color: #fff;

		ul {
			&.z-scroll {
				animation: listScroll 5s linear infinite;

				@keyframes listScroll {
					0% {
						transform: translate(0,0);
					}

					100% {
						transform: translate(0,-50%);
					}
				}
			}

			li {
				gap: .1rem;
				height: .45rem;
				border-radius: .06rem;
				padding: 0 .18rem 0 .12rem;
				margin: 0 .25rem .1rem;
				background: #1A2C45;
			}
		}

		&-type {
			border: 1px solid #4A84B6;
			border-radius: .1rem;
			padding: 0 .08rem;
			line-height: .18rem;
			font-size: .12rem;
			color: #D5EFFF;
			background: #31587A;
		}

		&-state {
			gap: .08rem;
			font-size: .12rem;
			color: #9FA3AA;

			&:before {
				content: '';
				width: .08rem;
				height: .08rem;
				border-radius: 50%;
				background: #42E907;
			}
		}
	}

	.repair {
		ul {
			li {
				gap: .1rem;
				height: .74rem;
				border-radius: .06rem;
				padding: 0 .22rem 0 .18rem;
				margin: 0 .25rem .1rem;
				background: #1A2C45;
			}
		}

		&-type {
			border: 1px solid #4A84B6;
			border-radius: .1rem;
			padding: 0 .08rem;
			line-height: .18rem;
			font-size: .12rem;
			color: #D5EFFF;
			background: #31587A;
		}

		&-name {
			margin-left: .08rem;
			font-size: .13rem;
			color: #fff;
		}

		&-info {
			gap: 1em;
			margin-top: .12rem;
			line-height: 1.2;
			font-size: .12rem;
			white-space: nowrap;
			color: #406F98;

			span {
				margin-left: .5em;
				color: #7ACAFC;
			}
		}

		&-state {
			gap: .08rem;
			border: 1px solid #F5A623;
			border-radius: .1rem;
			padding: 0 .1rem;
			line-height: .18rem;
			font-size: .12rem;
			color: #F5A623;
		}
	}

	.chart {
		margin-top: -.62rem;
	}
	
	.intact {
		padding: 0 .35rem .25rem;

		&-rate {
			font-size: .32rem;
			color: #00F8C1;

			&-bar {
				height: .08rem;
				border-radius: .04rem;
				margin: .16rem 0 .14rem;
				overflow: hidden;
				background: #31587A;

				div {
					height: 100%;
					background: #00F8C1;
				}
			}
		}

		&-info {
			font-size: .13rem;
			color: #406F98;
		}
	}
</style>
